import { Theme, createStyles } from '@material-ui/core';

const styles = ({ spacing, colors }: Theme) => createStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: spacing(2),
    paddingBottom: spacing(2),
  },
  separator: {
    display: 'inline-block',
    paddingLeft: spacing(1),
    paddingRight: spacing(1),
  },
  inputText: {
  },
  input: {
    justifyContent: 'center',
  },
  divider: {
    height: '2px',
    backgroundColor: colors.layout.divider300,
  },
});

export default styles;
